module.exports = __webpack_public_path__ + "img/smok_vape_2.f3a31dc8.png";